import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';

import { SelectedSlotDto, FirstStepData, MeetingDto, MeetingStatus } from '../../shared/model';
import { MainViewService } from '../main-view.service';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-third-step',
  templateUrl: './third-step.component.html',
  styleUrls: ['./third-step.component.css', '../../shared/styles/translation.css', '../main-view.component.css']
})
export class ThirdStepComponent implements OnChanges {
  @Input() active: boolean;
  @Input() firstStepValues: FirstStepData;
  @Input() secondStepValues: SelectedSlotDto;

  @Output() change: EventEmitter<boolean> = new EventEmitter();

  errorMessage: string;
  errorWhileCreating: boolean;
  success: boolean;
  counter = environment.redirectTimeInSeconds;

  constructor(
    private mainViewService: MainViewService,
    private router: Router,
    private spinnerService: SpinnerService) { }

  ngOnChanges() {
    if (this.active) {
      this.spinnerService.show('spinner');

      const meeting = this.constructMeeting();

      this.mainViewService.createMeeting(meeting)
        .subscribe(result => {
          if (result) {
            this.errorWhileCreating = false;
            this.success = true;
            this.spinnerService.hide('spinner');
            this.triggerCounter();
          }
        },
        () => {
          this.spinnerService.hide('spinner');
          this.errorWhileCreating = true;
        });
    }
  }

  private constructMeeting(): MeetingDto {
    return <MeetingDto>{
      Id: 0,
      AvailabilityId: this.secondStepValues.Id,
      Type: this.secondStepValues.MeetingType,
      Status: MeetingStatus.Active,
      CategoryId: this.secondStepValues.Category.Id,
      LanguageId: this.secondStepValues.Language.Id,
      Keyword: this.firstStepValues.Keyword ? this.firstStepValues.Keyword.Name : '',
      MismatchedKeyword: this.firstStepValues.MismatchedKeyword ? this.firstStepValues.MismatchedKeyword : '',
      PhoneNumber: this.secondStepValues.PhoneNumber,
      ProblemDescription: this.getProblemDescription(),
      AdditionalInformation: this.secondStepValues.ProblemDescription
    };
  }

  private getProblemDescription(): string {
    if (this.firstStepValues.MismatchedKeyword && this.firstStepValues.MismatchedKeyword.trim() !== '') {
      return this.firstStepValues.ProblemDescription ? this.firstStepValues.ProblemDescription : this.secondStepValues.ProblemDescription;
    }

    return '';
  }

  private triggerCounter() {
    if (this.counter > 0) {
      setTimeout(() => {
        this.counter--;
        this.triggerCounter();
      }, 1000);
    } else {
        this.router.navigateByUrl('/meetings');
    }
  }

}
